import React from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import { ErrorBoundary } from 'react-error-boundary';
import HtmlToReactErrorFallback from './html-to-react-error-fallback';

const Parse = ({ html, options }) => {
  return parse(html, options);
};

export const defaultOptions = {
  trim: false,
  replace: (domNode) => {
    if (domNode.type === 'tag') {
      switch (domNode.name) {
        case 'html':
        case 'body':
        case 'head':
          return <>{domToReact(domNode.children, defaultOptions)}</>;
        default:
          return domNode;
      }
    }

    return domNode;
  },
};

function getFallback(errors, html) {
  return <HtmlToReactErrorFallback {...errors} html={html} />;
}

function HtmlToReact({ html, options }) {
  return (
    <ErrorBoundary
      fallbackRender={(errors) => getFallback(errors, html)}
      resetKeys={[html]}
    >
      <Parse html={html || ''} options={options} />
    </ErrorBoundary>
  );
}

HtmlToReact.propTypes = {
  html: PropTypes.string,
  options: PropTypes.shape({}),
};

HtmlToReact.defaultProps = {
  html: null,
  options: defaultOptions,
};

export default HtmlToReact;
